import { Navigate } from "react-router";
/**
 * PrivateRoute
 *
 * مدیریت مسیرهای محافظت شده در اپلیکیشن:
 * - بررسی وجود توکن احراز هویت در localStorage
 * - اگر توکن موجود باشد، مسیر مورد نظر را رندر می‌کند
 * - در غیر این صورت کاربر را به صفحه ورود هدایت می‌کند
 *
 * @param children — کامپوننت‌ها یا مسیرهایی که باید محافظت شوند
 * @returns JSX.Element — مسیر محافظت شده یا ریدایرکت به صفحه ورود
 */

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
